import React, {Component} from 'react';
import {connect} from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import AppHeader from './header';
import AppFooter from './footer';
import PageContent from './page-content';
import LottieLoader from '../components/lottieLoader';
import { initLoader } from '../redux/actions/actions'; 

class App extends Component {
  render() {
    let { isLoading } = this.props;
    return (
      <>
      {
        isLoading?(
          <LottieLoader/>
        ):null
      }
        <Router>
          <AppHeader/>
            <PageContent/>
          <AppFooter/>
        </Router>
      </>
    )
  }
}

const mapStateToProps = ({linenedges}) => ({
  isLoading: linenedges.isLoading
});

export default connect(mapStateToProps)(App);